import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import SmsIcon from "@mui/icons-material/SmsOutlined";
import NoteIcon from "@mui/icons-material/StickyNote2Outlined";

const iconMap = {
  whatsapp: { Icon: WhatsAppIcon, color: "#25d366" },
  email: { Icon: EmailIcon, color: "#5b72e0" },
  sms: { Icon: SmsIcon, color: "#ffa348" },
  internal: { Icon: NoteIcon, color: "#94a3b8" },
};

export default React.memo(function ChannelBadge({ channel, size = 16 }) {
  const entry = iconMap[channel] || iconMap.internal;
  const { Icon, color } = entry;
  return <Icon sx={{ fontSize: size, color }} titleAccess={channel} />;
});
